import script from "./FeedbackHelpRequest.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeedbackHelpRequest.vue?vue&type=script&setup=true&lang=ts"

import "./FeedbackHelpRequest.vue?vue&type=style&index=0&id=76f9fe5a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76f9fe5a"]])

export default __exports__